import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowTriangleBottom"><Path d="M3.53613 4L11.9997 20.9271L20.4632 4H3.53613Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleBottom;
